<template>
  <div><div :id="sid+chartName" class="chart-wrapper" :style="esize"></div>
<div>
  <table class="d-table">
    <thead>
      <td>类别</td>
      <td>数量</td>
      <td>金额(元)</td>
      <td>金额占比</td>
    </thead>
    <tr v-for="(ele,index) in ctdata" :key="index">
      <td>{{ele.name}}</td>
      <td>{{ele.amount}}</td>
      <td>{{gformat(ele.value)}}</td>
      <td>{{percent(ele.value)}}</td>
    </tr>
  </table>
  </div></div>
</template>
<script>
//import { CounterAmount } from "@/libs/lib.js";
//import {chartText} from "@/libs/mixins/chartSubText.js";
import { numFormat } from "@/mixins/NumFormat.js";
export default {
  name: "workGroup",
  data() {
    return {
      chartName: this.$options.name,
      chartData: [{a:0,b:0}]
    };
  },
  props: {
    choosedOptions: {
      type: Object,
      default() {
        return {
          selectedList: [],
          keyword: ""
        };
      }
    },
    sid:{
      type:String,
      default:'a',
    },
    timeRange:{
      type:Number,
      default:1,
    },
    esize: {
      type: Object,
      default() {
        return { height: "15rem", width: "100%" };
      }
    },
    drawAgain: {
      type: Number,
      default: 1
    }
  },
  mixins: [numFormat],
  mounted() {},
  watch: {
    drawAgain: {
      immediate: true,
      handler(newVal) {
        if (newVal > 0) {
          this.get_data();
        }
      }
    }
  },
  computed: {
    ctdata() {
      return this.chartData;//Object.entries(CounterAmount(this.chartData, this.keyProp));
    },
    totalAmount(){
      let tmp = 0;
      for (let i of this.chartData){
        tmp += parseInt(i.value);
      }
      return tmp;
    },
    title(){
      if(this.timeRange===1){
        return "今日各实验室项目金额占比";
      }else{
        return "近"+this.timeRange+"日各实验室项目金额占比";
      }
    }
  },
  methods: {
    gformat(value){
      if(value){
        return this.commafy(parseFloat(value).toFixed(2));
      }else{
        return '-'
      }
      
    },
    percent(value){
      if(value){
        let x = parseFloat(value);
        let res = x/this.totalAmount;
        return (res*100).toFixed(2) + '%';
      }else{
        return '/';
      }
    },
    get_data() {
      let userToken = localStorage.getItem("current_user_token");
      this.$axios
        .post(this.$url + "/statistics", {
          askData: this.chartName,
          choosedOptions: this.choosedOptions,
          timeRange:this.timeRange,
          userToken: userToken
        })
        .then(response => {
          let tmp = [];
          for(let i of response.data){
            if(i.value&&parseInt(i.value)>0){
              tmp.push(i);
            }
          }
          tmp.sort((a,b)=>{
              return parseFloat(b.value)-parseFloat(a.value);
            });
          this.chartData = tmp;
          this.drawIt();
        });
    },
    drawIt() {
      let vm = this;
      let myChart = this.$echarts.init(document.getElementById(vm.sid+vm.chartName));
      // 绘制图表
      myChart.setOption({
        backgroundColor: "#fff",
        title: {
          text: vm.title,
          subtext: '',//vm.selectedListTextFormat(vm.choosedOptions.selectedList),
          left: "center",
          top: "6%",
          textStyle: {
            fontSize:'0.6rem',
            fontWeight:800,
            color: "#888"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: function(a){
            return a.data.name+':'+a.percent+'%</br>'+'￥'+a.data.value/10000+'万元';
          }
        },
        legend: {
          width:'80%',
          bottom: 20
        },
        dataset: {
          source: vm.ctdata
        },
        series: [
          {
            name: "数量",
            type: "pie",
            radius: ["25%", "45%"],
            center: ["50%", "50%"],
            
            itemStyle: {
              opacity: 0.9
            }
          }
        ],
        grid: {
          x: "20%",
          y: "20%",
          x2: "20%",
          y2: "20%",
          borderWidth: 10
        },
        label: {
          
          fontSize:'11',
          normal: {
            textStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            }
          }
        },
        labelLine: {
          normal: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            },
            smooth: 0.2,
            length: 10,
            length2: 20
          }
        }
      });
      /**myChart.on('click', function (value) {
                    vm.$emit("clickToChange", { 'value': [value.name], 'key': vm.chartKey });

                });**/
      myChart.on("legendselectchanged", function(value) {
        vm.$emit("clickToAppend", {
          value: value.selected,
          key: vm.keyProp
        });
      });
    }
  }
};
</script>
<style scoped>
.chart-wrapper {
  border: 1px solid #f9f9f9;
  border-radius: 3px;
  margin: 0 auto;
}
.d-table{
  margin:0 auto;
  border:3px double #666;
  border-collapse: collapse;
  width:80%;
  text-align: center;
  font-size: 0.5rem;
}

.d-table td{
  border:1px solid #999;
}
</style>